import { legalConfig } from '../config/legal';

type Props = {
  className?: string;
};

/** Reminder when staff creates a client account on behalf of someone. */
export function GdprClientConsentNotice({ className = '' }: Props) {
  return (
    <p className={`text-xs text-gray-600 leading-relaxed ${className}`}>
      En créant ce compte, vous confirmez avoir informé le client de la collecte de ses données pour la gestion
      du rendez-vous et du dossier boutique, conformément au RGPD. Le client peut exercer ses droits à{' '}
      <a href={`mailto:${legalConfig.privacyContactEmail}`} className="text-blue-700 underline">
        {legalConfig.privacyContactEmail}
      </a>
      . Consultez la{' '}
      <a
        href={legalConfig.privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-700 underline"
      >
        politique de confidentialité
      </a>
      .
    </p>
  );
}
